export default function Ifram() {
    return (
        <div>
            <iframe
                src="https://coda.io/embed/KA9pcNM40x/_sujg5?viewMode=embedplay"
                width="100%"
                height="800"
                allow="fullscreen"
                style={{ background: 'transparent', border: 'none' }}
            ></iframe>
        </div>
    );
}
